import React, { useState } from "react";
import "./LoginPage.css";
import logo from "../Image/logo-svcc.png";
import { loginUser, resetPassword } from "./FirebaseService";
import { useNavigate } from "react-router-dom";
import { message } from "antd";
import { loginWithGoogle } from "./FirebaseService";
import {
  EyeInvisibleOutlined,
  EyeOutlined,
  GoogleOutlined,
} from "@ant-design/icons";

const LoginPage = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [resetEmail, setResetEmail] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [identifier, setIdentifier] = useState("");

  const navigate = useNavigate();

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError("");

    try {
      const staffData = await loginUser(email, password);
      console.log("Logged in user:", staffData);

      if (staffData.designation !== "Librarian") {
        message.error("Access denied. Only Librarians can log in.");
        setIsLoading(false);
        return;
      }

      localStorage.setItem("staff", JSON.stringify(staffData));
      localStorage.setItem("userName", staffData.name);

      navigate("/dashboard");
    } catch (error) {
      message.error(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handleGoogleLogin = async () => {
    try {
      const staffData = await loginWithGoogle();
      localStorage.setItem("staff", JSON.stringify(staffData));

      navigate("/dashboard");
    } catch (error) {
      message.error(error.message);
    }
  };

  const handleResetPassword = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError("");
    try {
      await resetPassword(resetEmail);
      alert("Password reset email sent!");
      closeModal();
    } catch (error) {
      message.error(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-main-container">
      <form className="form" onSubmit={handleLogin}>
        <p id="heading">
          {" "}
          <img src={logo} />
          <p className="sign-in-text">Sign in to Library</p>
        </p>
        <div className="field">
          <svg
            className="input-icon"
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            viewBox="0 0 16 16"
          >
            <path d="M13.106 7.222c0-2.967-2.249-5.032-5.482-5.032-3.35 0-5.646 2.318-5.646 5.702 0 3.493 2.235 5.708 5.762 5.708.862 0 1.689-.123 2.304-.335v-.862c-.43.199-1.354.328-2.29.328-2.926 0-4.813-1.88-4.813-4.798 0-2.844 1.921-4.881 4.594-4.881 2.735 0 4.608 1.688 4.608 4.156 0 1.682-.554 2.769-1.416 2.769-.492 0-.772-.28-.772-.76V5.206H8.923v.834h-.11c-.266-.595-.881-.964-1.6-.964-1.4 0-2.378 1.162-2.378 2.823 0 1.737.957 2.906 2.379 2.906.8 0 1.415-.39 1.709-1.087h.11c.081.67.703 1.148 1.503 1.148 1.572 0 2.57-1.415 2.57-3.643zm-7.177.704c0-1.197.54-1.907 1.456-1.907.93 0 1.524.738 1.524 1.907S8.308 9.84 7.371 9.84c-.895 0-1.442-.725-1.442-1.914z"></path>
          </svg>
          <input
            autoComplete="off"
            placeholder="Email"
            className="input-field"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>
        <button className="button3" type="button" onClick={openModal}>
          Forgot Password?
        </button>
        <div className="field">
          <svg
            className="input-icon"
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            viewBox="0 0 16 16"
          >
            <path d="M8 1a2 2 0 0 1 2 2v4H6V3a2 2 0 0 1 2-2zm3 6V3a3 3 0 0 0-6 0v4a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2z"></path>
          </svg>
          <input
            placeholder="Password"
            className="input-field"
            type={showPassword ? "text" : "password"}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <span
            className="eye-icon"
            onClick={() => setShowPassword((prev) => !prev)}
          >
            {showPassword ? <EyeInvisibleOutlined /> : <EyeOutlined />}
          </span>
        </div>

        <div className="btn">
          <button className="button1" type="submit" disabled={isLoading}>
            {isLoading ? "Logging in..." : "Sign In"}
          </button>
        </div>

        <div className="divider">
          <span className="divider-text">or</span>
        </div>
        <button className="button2" type="button" onClick={handleGoogleLogin}>
          <GoogleOutlined className="google-icon" /> Sign in with Google
        </button>
      </form>

      {isModalOpen && (
        <div className="modal-overlay">
          <div className="modal">
            <h2>Forgot Your Password?</h2>
            <p>
              Please enter the email address associated with your Library
              Account, then check your inbox for password reset instructions.
            </p>
            <input
              type="email"
              className="input-field"
              placeholder="Email Address"
              value={resetEmail}
              onChange={(e) => setResetEmail(e.target.value)}
            />
            <button
              className="modal-btn"
              onClick={handleResetPassword}
              disabled={isLoading}
            >
              {isLoading ? "Sending..." : "Reset Password"}
            </button>
            <button className="modal-cancel" onClick={closeModal}>
              Back
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default LoginPage;
